module.exports = __webpack_public_path__ + "img/lh.096557ff.png";